import { IconWrapper } from '../runtime';
export default IconWrapper('diamond', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 48 48"
    }
  }, [h("g", {
    "attrs": {
      "stroke": "none",
      "stroke-width": props.strokeWidth,
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }, [h("g", {
    "attrs": {
      "transform": "translate(3.000000, 5.000000)",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth
    }
  }, [h("polygon", {
    "attrs": {
      "points": "7.63636364 0 34.3636364 0 42 13.3 21 38 0 13.3"
    }
  }), h("polyline", {
    "attrs": {
      "points": "7.63636364 0 21 38 34.3636364 0"
    }
  }), h("path", {
    "attrs": {
      "d": "M0,13.3 L42,13.3"
    }
  }), h("polyline", {
    "attrs": {
      "points": "12.4090909 13.3 21 0 29.5909091 13.3"
    }
  })])])]);
});